(function () {
  const initialized = new WeakSet();

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function init(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const story = root.querySelector('[data-cl3d-story]');
    const stage = root.querySelector('[data-cl3d-stage]');
    const panels = Array.from(root.querySelectorAll('[data-cl3d-panel]'));
    const video = root.querySelector('[data-cl3d-video]');
    if (!story || !stage || !panels.length) return;

    story.style.setProperty('--cl3d-chapters', panels.length);
    let queued = false;

    const render = () => {
      queued = false;
      const rect = story.getBoundingClientRect();
      const travel = Math.max(story.offsetHeight - window.innerHeight, 1);
      const progress = clamp(-rect.top / travel, 0, 1);
      const activeIndex = clamp(Math.floor(progress * panels.length), 0, panels.length - 1);

      stage.style.setProperty('--cl3d-progress', progress.toFixed(5));
      stage.style.setProperty('--cl3d-rotate', `${-22 + (progress * 360)}deg`);

      panels.forEach((panel, index) => {
        const isActive = index === activeIndex;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (video && Number.isFinite(video.duration) && video.duration > 0) {
        const targetTime = progress * Math.max(video.duration - 0.04, 0);
        if (Math.abs(video.currentTime - targetTime) > 0.015) {
          try {
            video.currentTime = targetTime;
          } catch (error) {
            // The next metadata or canplay event will retry the seek.
          }
        }
        root.classList.toggle('is-video-ready', video.readyState >= 2);
      }

      const percent = stage.querySelector('[data-cl3d-percent]');
      if (percent) percent.textContent = `${Math.round(progress * 100)}%`;
      root.dataset.chapter = String(activeIndex + 1);
    };

    const requestRender = () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(render);
    };

    render();
    if (video) {
      video.muted = true;
      video.pause();
      ['loadedmetadata', 'durationchange', 'canplay', 'seeked'].forEach((eventName) => {
        video.addEventListener(eventName, requestRender, { passive: true });
      });
    }
    window.addEventListener('scroll', requestRender, { passive: true });
    document.addEventListener('scroll', requestRender, { passive: true, capture: true });
    window.addEventListener('resize', requestRender, { passive: true });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cl3d-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

